export type FacilityProps = {
  id: number;
  name: string;
  slug: string;
  city: {
    id: number;
    name: string;
    slug: string;
    state: {
      id: number;
      name: string;
      slug: string;
    };
  };
  address: string;
  zipcode: string;
  lat: number;
  lng: number;
  image: {
    lg: string;
    md: string;
    sm: string;
    xs: string;
  };
  type: string;
};

export type UpcomingAuctionProps = {
  id: number;
  unit_number: string;
  type: string;
  image: {
    lg: string;
    md: string;
    sm: string;
    xs: string;
  };
};

export type DetailFacProps = FacilityProps & {
  manager_name: string;
  phone_number: string;
  email: string;
  website_url: string;
  website_information: string;
  upcoming_auctions: UpcomingAuctionProps[];
};

export type FaqProps = {
  id: number;
  attributes: {
    title: string;
    slug: string;
    keyword: string;
    short_description: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    cover: {
      data: ImgProps[] | null;
    };
  };
};

export type PageProps = {
  id: number;
  attributes: {
    title: string;
    slug: string;
    keyword: string;
    short_description: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    cover: {
      data: ImgProps | null;
    };
  };
};

export type DetailRegionProps = {
  city: {
    id: number;
    name: string;
    slug: string;
    state: {
      id: number;
      name: string;
      slug: string;
    };
  };
  state: {
    id: number;
    name: string;
    slug: string;
  };
  facilities: FacilityProps[];
  recent_adds: FacilityProps[];
};

export type ImgProps = {
  id: number;
  attributes: {
    name: string;
    alternativeText: string;
    caption: string;
    width: number;
    height: number;
    formats: string | null;
    hash: string;
    ext: string;
    mime: string;
    size: number;
    url: string;
    previewUrl: string | null;
    provider: string;
    provider_metadata: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type GeneralInformationProps = {
  id?: number;
  attributes: {
    footer_header_title: string;
    footer_header_description: string;
    footer_description: string;
    createdAt: string;
    updatedAt: string;
    icon: {
      data: ImgProps | null;
    };
    logo: {
      data: ImgProps | null;
    };
    logo_light: {
      data: ImgProps | null;
    };
  };
};

export type FooterLinks = {
  id: number;
  attributes: {
    name: string;
    url: string;
    queue: number;
    createdAt: string;
    updatedAt: string;
  };
};

export type FooterGroupProps = {
  id: number;
  attributes: {
    name: string;
    queue: number;
    createdAt: string;
    updatedAt: string;
    footer_links: {
      data: FooterLinks[];
    };
  };
};

export type ReviewsProps = {
  id: number;
  attributes: {
    name: string;
    title: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    photo: {
      data: ImgProps | null;
    };
  };
};

export type USProps = {
  id: number;
  name: string;
  slug: string;
  total: number;
  cities: {
    id: number;
    name: string;
    slug: string;
    total: number;
  }[];
};

export type InfoProps = {
  information: GeneralInformationProps;
  footer: FooterGroupProps[];
};

export type GeocodeResultProps = {
  address_components: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  formatted_address: string;
  geometry: {
    location: {
      lat: () => number | number;
      lng: () => number | number;
    };
    location_type: string;
    viewport:
      | google.maps.LatLngBounds
      | {
          south: number;
          west: number;
          north: number;
          east: number;
        };
  };
  place_id: string;
  plus_code?: google.maps.places.PlacePlusCode | undefined;
  types: string[];
};

export type CalculateProps = {
  city: string;
  zipcode: string;
  found: {
    facilities: any[];
    upcoming_auction: number;
    avg_auction_monthly: number;
  };
  pricing: {
    monthly: number;
    yearly: number;
    yearly_save_value: number;
    yearly_save_percentage: number;
  };
};

export const CalculateDefaultValue = {
  city: "",
  zipcode: "",
  found: {
    facilities: [],
    upcoming_auction: 0,
    avg_auction_monthly: 0,
  },
  pricing: {
    monthly: 0,
    yearly: 0,
    yearly_save_value: 0,
    yearly_save_percentage: 0,
  },
};

export type calculateParamsProps = {
  lat: string;
  lng: string;
  radius: string | number | null;
  times: string;
  map_zoom?: number | null;
  total?: number;
};

export type FacilityTypes = {
  id: number;
  name: string;
  lat: number | any;
  lng: number | any;
  address: string;
  image: {
    lg: string;
    md: string;
    sm: string;
    xs: string;
  };
  auctions: {
    upcoming: number;
    ended: number;
  };
  total?: number;
};
